require("core-js/modules/es.array.reduce.js");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : (e = e || self).htmr = t(e.React);
}(this, function (e) {
  "use strict";

  function t(e) {
    return e.replace(/(-|:)(.)/g, function (e, t, r) {
      return r.toUpperCase();
    });
  }

  function r(e) {
    var r = {};
    return e.split(";").filter(function (e) {
      return "" !== e.trim();
    }).forEach(function (e) {
      var n,
          a = e.split(":");

      if (a.length > 1) {
        var o = function (e) {
          return /^-ms-/.test(e) && (e = e.substr(1)), t(e);
        }(a[0].trim()),
            i = (n = a.slice(1).join(":").trim(), /^\d+$/.test(n) ? Number(n) : n.replace(/'/g, '"'));

        r[o] = i;
      }
    }), r;
  }

  e = e && e.hasOwnProperty("default") ? e.default : e;
  var n = {
    for: "htmlFor",
    class: "className",
    acceptcharset: "acceptCharset",
    accesskey: "accessKey",
    allowfullscreen: "allowFullScreen",
    allowtransparency: "allowTransparency",
    autocomplete: "autoComplete",
    autofocus: "autoFocus",
    autoplay: "autoPlay",
    cellpadding: "cellPadding",
    cellspacing: "cellSpacing",
    charset: "charSet",
    classid: "classID",
    classname: "className",
    colspan: "colSpan",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    crossorigin: "crossOrigin",
    datetime: "dateTime",
    enctype: "encType",
    formaction: "formAction",
    formenctype: "formEncType",
    formmethod: "formMethod",
    formnovalidate: "formNoValidate",
    formtarget: "formTarget",
    frameborder: "frameBorder",
    hreflang: "hrefLang",
    htmlfor: "htmlFor",
    httpequiv: "httpEquiv",
    inputmode: "inputMode",
    keyparams: "keyParams",
    keytype: "keyType",
    marginheight: "marginHeight",
    marginwidth: "marginWidth",
    maxlength: "maxLength",
    mediagroup: "mediaGroup",
    minlength: "minLength",
    novalidate: "noValidate",
    radiogroup: "radioGroup",
    readonly: "readOnly",
    rowspan: "rowSpan",
    spellcheck: "spellCheck",
    srcdoc: "srcDoc",
    srclang: "srcLang",
    srcset: "srcSet",
    tabindex: "tabIndex",
    usemap: "useMap",
    viewbox: "viewBox"
  };
  var a = {
    ELEMENT: 1,
    TEXT: 3,
    COMMENT: 8
  },
      o = ["table", "tbody", "thead", "tfoot", "tr"];

  function i(l, s, c) {
    var u = c.transform._;
    if (l.nodeType === a.COMMENT) return null;

    if (l.nodeType === a.TEXT) {
      var d = l.textContent;
      return u ? u(d) : d;
    }

    for (var f = l.tagName.toLowerCase(), m = c.transform[f], p = {}, h = 0; h < l.attributes.length; h++) {
      var g = l.attributes[h].name,
          y = l.attributes[h].value;
      p[g] = y;
    }

    p.key = s.toString();

    var v = function (e, a) {
      return void 0 === e && (e = {}), Object.keys(e).reduce(function (o, i) {
        if (/^on.*/.test(i)) return o;
        var l = i;
        /^(data|aria)-/.test(i) || 0 === a.filter(function (e) {
          return e instanceof RegExp ? e.test(i) : e === i;
        }).length && (l = t(i));
        var s = n[l] || l;
        if ("style" === s) o[s] = r(e.style);else {
          var c = e[i],
              u = "" === c || String(c).toLowerCase() === l.toLowerCase();
          o[s] = !!u || c;
        }
        return o;
      }, {});
    }(p, c.preserveAttributes),
        T = [];

    for (h = 0; h < l.childNodes.length; h++) {
      var E = l.childNodes[h],
          b = s + "." + h;

      if (!(o.indexOf(f) > -1 && E.nodeType === a.TEXT && (E.textContent = E.textContent.trim(), "" === E.textContent))) {
        var x = i(E, b, c);
        null !== x && T.push(x);
      }
    }

    if (c.dangerouslySetChildren.indexOf(f) > -1) {
      var C = l.innerHTML;
      return C && ("style" !== f && "script" !== f && (C = C.replace(/"/g, "&quot;")), v.dangerouslySetInnerHTML = {
        __html: C.trim()
      }), m ? e.createElement(m, v, null) : u ? u(f, v, null) : e.createElement(f, v, null);
    }

    var w = 0 === T.length ? null : T;
    return m ? e.createElement(m, v, w) : u ? u(f, v, w) : e.createElement(f, v, w);
  }

  return function (e, t) {
    if (void 0 === t && (t = {}), "string" != typeof e) throw new TypeError("Expected HTML string");
    var r = {
      transform: t.transform || {},
      preserveAttributes: t.preserveAttributes || [],
      dangerouslySetChildren: t.dangerouslySetChildren || ["style"]
    },
        n = document.createElement("div");
    n.innerHTML = e.trim();

    for (var a = [], o = 0; o < n.childNodes.length; o++) {
      a.push(n.childNodes[o]);
    }

    var l = a.map(function (e, t) {
      return i(e, String(t), r);
    }).filter(function (e) {
      return null !== e;
    });
    return 1 === l.length ? l[0] : l;
  };
});